import { 
  useColorMode,
  useColorModeValue,
  IconButton,
} from '@chakra-ui/react';

import {
  BiSun,
  BiMoon
} from 'react-icons/bi'

export const ColorModeSwitch = props => {
  const { toggleColorMode } = useColorMode()
  const SwitchIcon = useColorModeValue(BiMoon, BiSun);

  return (
    <IconButton
      icon={<SwitchIcon />}
      variant={'ghost'}
      aria-label="Toggle Theme"
      onClick={toggleColorMode}
      {...props}
    />
  )
}
